import './SkeletonOverlay.css';
import { Skeleton } from './Skeleton';

export type SkeletonOverlayProps = {
    lines?: number;
    className?: string;
};

export function SkeletonOverlay({ lines = 4, className = '' }: SkeletonOverlayProps) {
    return (
        <div
            className={`skeleton-overlay ${className}`}
            role="status"
            aria-busy="true"
            aria-label="Loading"
        >
            {Array.from({ length: lines }, (_, i) => {
                const widths = ['88%', '72%', '94%', '56%', '80%', '65%'];
                const width = widths[i % widths.length] ?? '80%';
                return <Skeleton key={i} width={width} height="12px" />;
            })}
        </div>
    );
}
